// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctNoiseReductionNr_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 2H2V22H22V2ZM0 0V24H24V0H0Z" class="svg-bg"/>
  <path d="M12 16.782H9.504L5.461 9.762H5.409C5.42633 10.204 5.44366 10.646 5.461 11.088 5.487 11.53 5.50866 11.972 5.526 12.414V16.782H3.771V7.5H6.254L10.284 14.455H10.323C10.3057 14.0303 10.2883 13.6057 10.271 13.181 10.2537 12.7563 10.2407 12.3273 10.232 11.894V7.5H12V16.782ZM15.704 7.5C16.9693 7.5 17.901 7.72967 18.499 8.189 19.1057 8.64833 19.409 9.346 19.409 10.282 19.409 10.7067 19.3267 11.0793 19.162 11.4 19.006 11.712 18.7937 11.9807 18.525 12.206 18.265 12.4227 17.9833 12.6003 17.68 12.739L20.41 16.782H18.226L16.016 13.22H14.963V16.782H13V7.5H15.704ZM15.561 9.112H14.963V11.621H15.6C16.25 11.621 16.7137 11.5127 16.991 11.296 17.277 11.0793 17.42 10.7587 17.42 10.334 17.42 9.892 17.2683 9.58 16.965 9.398 16.6617 9.20733 16.1937 9.112 15.561 9.112Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOctNoiseReductionNr is a generated icon component.
 */
let IconMedOctNoiseReductionNr = IconMedOctNoiseReductionNr_1 = class IconMedOctNoiseReductionNr extends IconBaseElement {
    render() {
        return html `${IconMedOctNoiseReductionNr_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctNoiseReductionNr.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOctNoiseReductionNr = IconMedOctNoiseReductionNr_1 = __decorate([
    customElement('zui-icon-med-oct-noise-reduction-nr')
], IconMedOctNoiseReductionNr);
export { IconMedOctNoiseReductionNr };
